import { endOfDay, format, startOfDay } from 'date-fns';

import { ListSystemLogs } from '../api/queries/list-system-logs';
import type { Filters } from '../view/state/selected-filters';

import { getUnitFromFilter } from './get-unit-from-filter';

type FilterQueryParams = Omit<ListSystemLogs.QueryParams, 'limit' | 'offset'>;

export function getQueryParamsFromFilters({
  systemId,
  filters,
}: {
  systemId?: string;
  filters?: Filters;
}): FilterQueryParams {
  const queryParams: FilterQueryParams = {};
  // site_accure_id: string, optional
  const siteFromFilters = filters?.coreFilters.siteId;
  if (siteFromFilters) {
    queryParams.siteAccureId = siteFromFilters;
  } else if (systemId) {
    queryParams.siteAccureId = systemId;
  }

  if (!filters) {
    return queryParams;
  }

  // start_date, end_date: ISO string
  if (filters.coreFilters.dateRange.from) {
    queryParams.startDate = format(
      startOfDay(filters.coreFilters.dateRange.from),
      "yyyy-MM-dd'T'HH:mm:ss",
    );
  }
  if (filters.coreFilters.dateRange.to) {
    queryParams.endDate = format(
      endOfDay(filters.coreFilters.dateRange.to),
      "yyyy-MM-dd'T'HH:mm:ss",
    );
  }

  if (filters.coreFilters.domain) {
    queryParams.domain = filters.coreFilters.domain as 'battery' | 'pcs';
  }

  // unit_accure_id: optional, set for battery/pcs
  const { accureId: unitAccureId } = getUnitFromFilter(filters);

  if (unitAccureId) {
    queryParams.unitAccureId = unitAccureId;
  }

  return queryParams;
}
